import {direction} from 'src/shared/config'

import {MarginRectFunction} from './types'

// функция возвращает нужное смещение маргина левого элемена на странице с учетом направления текста
// ┌───────┐
// │┌─┐    │
// ││ │←   │
// │└─┘    │
// └───────┘
export const getStartOffset: MarginRectFunction<HTMLElement> = el => {
  if (direction === 'rtl') {
    return {
      right: window.innerWidth - el.offsetLeft,
    }
  }

  return {
    left: el.offsetLeft + el.offsetWidth,
  }
}

// функция возвращает нужное смещение маргина правого элемена на странице с учетом направления текста
// ┌──────┐
// │   ┌─┐│
// │  →│ ││
// │   └─┘│
// └──────┘
export const getEndOffset: MarginRectFunction<HTMLElement> = el => {
  if (direction === 'rtl') {
    return {
      left: el.offsetLeft + el.offsetWidth,
    }
  }

  return {
    right: window.innerWidth - el.offsetLeft,
  }
}
